// @flow

import Request from '@insolus/request';

import type { RequestPromise } from '@insolus/request';
import type { Advertiser } from './advertisers';
import type { PublishData } from 'stores/api/ads';

export type UserGroup = 'admin' | 'advertiser';

export type CurrentUser = {|
    id: number,
    group: UserGroup,
    email: string,
    hasBillingData?: boolean,
    isEmailConfirmed: boolean,
    profile: Advertiser,
    credits: number,
    draftId?: number
|};

export type TokenUser = CurrentUser & { token: string };

// ------------------------------------------------------
// -
// -    Codes
// -
// ------------------------------------------------------

export const WRONG_LOGIN_CREDENTIALS = 'user/1';
export const INACTIVE_ACCOUNT = 'user/2';

// ------------------------------------------------------
// -
// -    Functions
// -
// ------------------------------------------------------

const fetch = (): RequestPromise<CurrentUser> => Request.get('/session');

const login = (
    email: string,
    password: string,
    draft?: PublishData | null = null
): RequestPromise<TokenUser> => (
    Request.post('/session', { email, password, draft })
);

export default { fetch, login };
